import config from '../../config'

export const FIRST_CALORIE_FLOOR_FACTOR = 22;
export const SECOND_CALORIE_FLOOR_FACTOR = 19.5;
export const MINIMUM_CARBS = 30;
export const ALGORITHM_VERSION_NEW_ACTIVITY_FACTORS = 23;
export const ALGORITHM_VERSION_CURRENT = 23;
export const LBS_PER_KG = 2.204622;

export function getDaysSinceWeighIn(weighInDate) {
  const now = new Date()
  const nowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate())

  const since = new Date(weighInDate)
  const sinceDate = new Date(since.getUTCFullYear(), since.getUTCMonth(), since.getUTCDate())

  // Daylight savings check and adjustment
  const offsetDiff = (nowDate.getTimezoneOffset() - sinceDate.getTimezoneOffset())/60
  if(offsetDiff !== 0)
    sinceDate.setUTCHours(sinceDate.getUTCHours() + offsetDiff)

  return Math.floor((nowDate - sinceDate) / 86400000)
}

export function getDaysUntilWeighIn(lastWeighInDate) {
  const now = new Date()
  const nowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const next = new Date(lastWeighInDate)
  next.setUTCDate(next.getUTCDate() + 7)
  const nextDate = new Date(next.getUTCFullYear(), next.getUTCMonth(), next.getUTCDate())
  const daysUntilWeighIn = Math.ceil((nextDate - nowDate)/(1000*3600*24))

  return (daysUntilWeighIn < 0) ? 0 : daysUntilWeighIn
}

export function getDaysUntilCancellation(endDate) {
  const now = new Date()
  const nowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const next = new Date(endDate)
  next.setUTCDate(next.getUTCDate())
  const nextDate = new Date(next.getUTCFullYear(), next.getUTCMonth(), next.getUTCDate())
  const daysUntilCancellation = Math.ceil((nextDate - nowDate)/(1000*3600*24))

  return (daysUntilCancellation < 0) ? 0 : daysUntilCancellation
}

export function getMacroDelta(actualValue, lowValue, lowDelta, highValue, highDelta) {
  let delta

  if (actualValue <= lowValue) {
    delta = (actualValue < lowDelta) ? actualValue : lowDelta
  } else if (actualValue >= highValue) {
    delta = highDelta
  } else {
    delta = lowDelta + (highDelta - lowDelta) * (actualValue - lowValue) / (highValue - lowValue)
  }
  return delta
}

export function getProteinDelta(grams) {
  return getMacroDelta(grams, 100, 10, 250, 15)
}

export function getCarbsDelta(grams) {
  return getMacroDelta(grams, 50, 5, 500, 16)
}

export function getFatDelta(grams) {
  return getMacroDelta(grams, 25, 4, 175, 8)
}

export function getPastDueDate(pastDueAt) {
  const date = new Date(pastDueAt)
  date.setUTCDate(date.getUTCDate())
  const pastDate = date.getUTCMonth()+1 + '/' + date.getUTCDate()

  return pastDate
}

export function getFirstName(fullname) {
  if(!fullname)
    return

  let firstName = fullname
  const tokens = fullname.split(' ')
  if(tokens.length >= 2) {
    firstName = tokens[0]
    if(firstName.length === 1)
      firstName += ' ' + tokens[1]
  }

  return firstName
}

export function shouldShowCompliant(startingPoint, weighin, prevWeighIn, weighins, selectedWeighInIndex) {
  const now = new Date()
  const currentDate = new Date(now.getFullYear(), now.getMonth(), now.getDate())

  const startingPointDate = new Date(startingPoint)
  let prevWeighInDate
  if(prevWeighIn) {
    prevWeighInDate = new Date(prevWeighIn.report_date)
  } else {
    prevWeighInDate = new Date(startingPoint)
  }
  const weighinDate = new Date(weighin.report_date)
  const startingPointUTC = new Date(startingPointDate.getUTCFullYear(), startingPointDate.getUTCMonth(), startingPointDate.getUTCDate())
  const prevWeighinUTC = new Date(prevWeighInDate.getUTCFullYear(), prevWeighInDate.getUTCMonth(), prevWeighInDate.getUTCDate())
  const weighinUTC = new Date(weighinDate.getUTCFullYear(), weighinDate.getUTCMonth(), weighinDate.getUTCDate())
  const daysSincePrevWeighIn = Math.floor((weighinUTC - prevWeighinUTC) / 86400000)
  const isStartingPointToday = (startingPointUTC.toDateString() === currentDate.toDateString())
  const isPrevWeighinStartingPoint = (selectedWeighInIndex === Object.keys(weighins).length - 1 || startingPointUTC.toDateString() === weighinUTC.toDateString())

  if(isStartingPointToday || isPrevWeighinStartingPoint || daysSincePrevWeighIn < 5 || weighin.resuming)
    return false

  return true
}

export function getCarryOverReasons(goal) {
  let reasons
  switch(goal) {
    case 'FAT LOSS':
      reasons = [
        [ 1, "I'm happy with my progress"],
        [ 2, "My activity level was unusual last week"],
        [ 4, "I'm planning to exercise more this week"],
        [ 8, "I think I'm retaining water weight"],
        [16, "I'm planning to exercise less this week"]
      ]
      break

    case 'MUSCLE GAIN':
      reasons = [
        [ 1, "I'm happy with my progress"],
        [ 2, "My activity level was unusual last week"],
        [ 4, "I'm planning to exercise less this week"],
        [ 8, "I want to minimize fat gain"],
        [16, "I'm planning to exercise more this week"],
        [32, "I think I'm retaining water weight"]
      ]
      break

    case 'REVERSE DIETING':
      reasons = [
        [ 1, "I want extra time to adapt"],
        [ 2, "My activity level was unusual last week"],
        [ 4, "I'm planning to exercise less this week"],
        [ 8, "I want to minimize fat gain"]
      ]
      break

    case 'MAINTENANCE':
      reasons = [
        [ 1, "My activity level was unusual last week"],
        [ 2, "I'm planning to exercise more"],
        [ 4, "I think I'm retaining water weight"],
        [ 8, "I'm planning to increase my weight range"],
        [16, "I'm planning to exercise less"],
        [32, "I want to lower my weight range"]
      ]
      break

    default:
      reasons = []
  }
  return reasons
}

function amountGoalReached(targetWeight, latestWeight, prevWeight, daysSinceWeighIn) {
  let weightDelta = latestWeight - prevWeight
  let targetDelta = targetWeight - prevWeight

  if(daysSinceWeighIn > 0)
    weightDelta = weightDelta * (7 / daysSinceWeighIn)

  if(targetDelta === 0)
    return 0
  else
    return weightDelta / targetDelta
}

function amountGoalReachedByBF(targetWeight, latestWeight, latestBodyFat, prevWeight, prevBodyFat, daysSinceWeighIn) {
  let bfmDelta = latestWeight * (latestBodyFat/100) - prevWeight * (prevBodyFat/100)
  let targetDelta = targetWeight - prevWeight

  if(daysSinceWeighIn > 0)
    bfmDelta = bfmDelta * 7 / daysSinceWeighIn

  if(targetDelta === 0)
    return 0
  else
    return bfmDelta / targetDelta
}

export function getCalorieIncrease(goalMinWeeklyCalorieIncrease, gender, caloriesFromCarbsAndFat) {
  let calorieIncrease;
  if(gender === 'MALE') {
    if(caloriesFromCarbsAndFat < 1000) {
      calorieIncrease = goalMinWeeklyCalorieIncrease;
    } else if(caloriesFromCarbsAndFat > 2500) {
      calorieIncrease = goalMinWeeklyCalorieIncrease + 15;
    } else {
      calorieIncrease = goalMinWeeklyCalorieIncrease + 15 * (caloriesFromCarbsAndFat - 1000) / 1500;
    }
  } else { // female
    if(caloriesFromCarbsAndFat < 800) {
      calorieIncrease = goalMinWeeklyCalorieIncrease;
    } else if(caloriesFromCarbsAndFat > 2000) {
      calorieIncrease = goalMinWeeklyCalorieIncrease + 15;
    } else {
      calorieIncrease = goalMinWeeklyCalorieIncrease + 15 * (caloriesFromCarbsAndFat - 800) / 1200;
    }
  }

  return calorieIncrease;
}

function getWeightChanged(newWeight, oldWeight, daysSinceWeighIn) {
  let weightChanged = newWeight/oldWeight - 1
  if(daysSinceWeighIn > 0)
    weightChanged = weightChanged * 7 / daysSinceWeighIn
  return weightChanged
}

// Get protein based on various factors.
export function getProteins(age, weight, bodyfat, goal, activityFactor, vegan, extra, algorithmVersion) {
  let protein = weight * (1 - bodyfat / 100) * (extra <= 100 ? 2.2 : (extra > 200 ? 1.8 : 2.6 - extra / 250))

  // - Add additional 10% protein for FAT LOSS goal (calorie restricted plan)
  if(goal === 'FAT LOSS') protein += protein * 0.10

  // - Add additional 0.25% protein for every year after 40
  if(age > 40) protein += protein * (age - 40) * 0.0025

  // - Add additional 12.5% protein for vegan
  if(vegan) protein += protein * 0.125

  // - Add based on activity factor.
  //  1.1 => 0 grams
  //  1.2 => 5 grams
  //  1.4 => 10 grams
  //  1.6 => 15 grams
  //  1.8 => 20 grams
  //  Occurs linearly, so 1.15 => 2.5 grams
  if (algorithmVersion >= ALGORITHM_VERSION_NEW_ACTIVITY_FACTORS) {
    protein += (activityFactor * 200 - 240) / 7
  } else if(activityFactor < 1.2) {
    protein += (activityFactor - 1.1) * 50.0
  } else {
    protein += (activityFactor - 1.0) * 25.0
  }

  // - Add additional protein requested in advanced features
  if (extra <= 100) {
    protein += extra * weight * 0.005
  }

  return protein
}

// Get carbs as calorie leftovers after proteins and fats
export function getCarbs(calories, protein, fat) {
  return (calories - protein * 4 - fat * 9) / 4;
}

// Get fat as selected per-myriad of total calories.
export function getFats(fatPermyriad, calories) {
  return calories * fatPermyriad / 90000;
}

// Convert an activity level (0 to 4) to an activity factor (1.1 to 1.8, or 1.2 to 1.9).
export function activityLevelToFactor(activityLevel, user) {
  let activityHours = activityLevel
  let activityFactor

  if(activityHours < 0) {
    activityHours = 0
  } else if(activityHours > 4) {
    activityHours = 4
  }

  if(user.algorithm_version >= ALGORITHM_VERSION_NEW_ACTIVITY_FACTORS) {
    activityFactor = activityHours * 0.175 + 1.2
  } else if(activityHours < 1) {
    activityFactor = activityHours * 0.1 + 1.1
  } else {
    activityFactor = activityHours * 0.2 + 1
  }

  return activityFactor
}

// Get carry-over environment for check-in being edited. Should be called once at start of editing a check-in.
//
// selectedCheckIn: state.user.weighins entry for check-in being edited
//
// previousCheckIn: state.user.weighins entry for check-in immediately prior to one being edited
//
// Returns carryOverEnvironment, to be passed to getCarryOverInfo later.
export function getCarryOverEnvironment(selectedCheckIn, previousCheckIn) {
  let carryOverEnvironment = {
    potentiallyKeepable: false,
    selectedReportDate: null,
    selectedGoal: null,
    selectedVegan: null,
    selectedTargetWeight: null,
    selectedGoalWeightDelta: null,
    selectedGoalMinWeeklyCalorieIncrease: null,
    selectedFatPermyriad: null,
    selectedActivityFactor: null,
    selectedInitialWeek: null,
    previousWeight: null,
    previousBodyFat: null,
    previousProtein: null,
    previousCarbs: null,
    previousFat: null,
    daysBetweenCheckIns: null
  }
  if (previousCheckIn.raw_protein !== null) {
    if (selectedCheckIn.keep) {
      carryOverEnvironment.potentiallyKeepable = true
    } else if (selectedCheckIn.resuming === '' && selectedCheckIn.algorithm !== null) {
      if (!selectedCheckIn.compliant) {
        carryOverEnvironment.potentiallyKeepable = true
      } else {
        switch (selectedCheckIn.algorithm) {
          case 'FAT LOSS':
          case 'MUSCLE GAIN':
          case 'REVERSE DIETING':
          case 'MAINTENANCE':
          case 'CARRY OVER':
            if (!selectedCheckIn.is_initial) {
              carryOverEnvironment.potentiallyKeepable = true
            }
            break

          default:
        }
      }
    }
    if (carryOverEnvironment.potentiallyKeepable) {
      carryOverEnvironment.selectedReportDate = selectedCheckIn.report_date
      carryOverEnvironment.selectedGoal = selectedCheckIn.goal
      carryOverEnvironment.selectedVegan = selectedCheckIn.vegan
      carryOverEnvironment.selectedTargetWeight = selectedCheckIn.target_weight
      carryOverEnvironment.selectedGoalWeightDelta = selectedCheckIn.goal_weight_delta
      carryOverEnvironment.selectedGoalMinWeeklyCalorieIncrease = selectedCheckIn.goal_min_weekly_calorie_increase
      carryOverEnvironment.selectedFatPermyriad = selectedCheckIn.fat_permyriad
      carryOverEnvironment.selectedActivityFactor = selectedCheckIn.activity_factor
      carryOverEnvironment.selectedInitialWeek = selectedCheckIn.initial_week
      carryOverEnvironment.previousWeight = (previousCheckIn.inflated && previousCheckIn.estimated_weight !== null) ? previousCheckIn.estimated_weight : (previousCheckIn.edited_weight !== null ? previousCheckIn.edited_weight : previousCheckIn.weight)
      carryOverEnvironment.previousBodyFat = previousCheckIn.edited_body_fat !== null ? previousCheckIn.edited_body_fat : previousCheckIn.body_fat
      carryOverEnvironment.previousProtein = previousCheckIn.raw_protein
      carryOverEnvironment.previousFat = previousCheckIn.raw_fat
      carryOverEnvironment.previousCarbs = previousCheckIn.raw_carbs
      carryOverEnvironment.daysBetweenCheckIns = daysBetweenDateStrings(hostDateToString(previousCheckIn.report_date), hostDateToString(selectedCheckIn.report_date))
    }
  }
  return carryOverEnvironment
}

// Dynamically determine whether the check-in being edited is keepable, and if so, generate the old and new macros.
// The edit check-in screen should first call getCarryOverEnvironment, during its initialization.
// Then on first render, and whenever the weight, body fat, compliant flag or menstrual flag changes,
// it should call this function if the edited check-in is now compliant.
// (If it is not compliant, or if the weight or body fat is invalid, the adjustment block should not be shown.)
//
// newWeight: new weight in kg
//
// newBodyFat: new body fat
//
// effectiveNearPeriod: new value of near_period
//
// carryOverEnvironment: saved return value from getCarryOverEnvironment
//
// userProps: state.user.data
//
// Returns { keepable: true_or_false, reasonsMask: integer, macros: { old: { protein, carbs, fat }, new: { protein, carbs, fat } } }
// If keepable is true, the adjustment block should be shown, with the specified old and new macros.
export function getCarryOverInfo(newWeight, newBodyFat, effectiveNearPeriod, carryOverEnvironment, userProps) {
  let keepable = false
  let reasonsMask = 0
  let macros = {old: {}, new: {}}
  let adj = 0
  let goalRatio
  let limitFactor
  let limitOffset

  if (carryOverEnvironment.potentiallyKeepable) {
    const latestWeightInLbs = newWeight * LBS_PER_KG
    // Check if keepable, based on the goal.
    switch (carryOverEnvironment.selectedGoal) {
      case 'FAT LOSS':
        const fatLossTargetWeight = carryOverEnvironment.previousWeight - carryOverEnvironment.selectedGoalWeightDelta
        let goalCompletedWithBodyFat = false
        let fatLossGoalCompleted = amountGoalReached(fatLossTargetWeight, newWeight, carryOverEnvironment.previousWeight, carryOverEnvironment.daysBetweenCheckIns)
        if (fatLossGoalCompleted <= 0) {
          if (newBodyFat < carryOverEnvironment.previousBodyFat) {
            fatLossGoalCompleted = amountGoalReachedByBF(fatLossTargetWeight, newWeight, newBodyFat, carryOverEnvironment.previousWeight, carryOverEnvironment.previousBodyFat, carryOverEnvironment.daysBetweenCheckIns)
            goalCompletedWithBodyFat = true
          }
        }
        if (fatLossGoalCompleted < 1 && !effectiveNearPeriod) {
          keepable = true
          if (fatLossGoalCompleted < 0) {
            reasonsMask = 2 + 4 + 8
            adj = -0.15
          } else {
            reasonsMask = 1 + 2 + 4 + 8
            adj = (fatLossGoalCompleted - 1) * 15 / 100
          }
        } else if (fatLossGoalCompleted > 1 && !goalCompletedWithBodyFat) {
          const scaledLossInLbs = fatLossGoalCompleted * (carryOverEnvironment.previousWeight - fatLossTargetWeight) * LBS_PER_KG
          goalRatio = carryOverEnvironment.selectedGoalWeightDelta / carryOverEnvironment.previousWeight
          if (goalRatio < 0.004) {
            goalRatio = 0.004
          } else if (goalRatio > 0.012) {
            goalRatio = 0.012
          }
          const fatLossOffset100 = carryOverEnvironment.selectedInitialWeek ? 2.2 + (goalRatio - 0.004) * 50 : 1.2
          const fatLossOffset500 = carryOverEnvironment.selectedInitialWeek ? 4.0 - (goalRatio - 0.004) * 100 : 1.8
          if(latestWeightInLbs < 100) {
            limitFactor = goalRatio
            limitOffset = fatLossOffset100
          } else if(latestWeightInLbs > 500) {
            limitFactor = goalRatio
            limitOffset = fatLossOffset500
          } else {
            limitFactor = goalRatio + (fatLossOffset500 - fatLossOffset100) / 400
            limitOffset = fatLossOffset100 - (fatLossOffset500 - fatLossOffset100) / 4
          }
          const allowedWeightLossInLbs = latestWeightInLbs * limitFactor + limitOffset
          if(scaledLossInLbs > allowedWeightLossInLbs) {
            let fatLossCalorieIncrease
            if(latestWeightInLbs < 100) {
              fatLossCalorieIncrease = 100
            } else if (latestWeightInLbs > 500) {
              fatLossCalorieIncrease = 300
            } else {
              fatLossCalorieIncrease = (latestWeightInLbs - 100) * 0.5 + 100
            }
            if(scaledLossInLbs > allowedWeightLossInLbs + 2) {
              fatLossCalorieIncrease += 100
            } else {
              fatLossCalorieIncrease += (scaledLossInLbs - allowedWeightLossInLbs) * 50
            }
            keepable = true
            adj = fatLossCalorieIncrease / (4 * carryOverEnvironment.previousCarbs + 9 * carryOverEnvironment.previousFat)
            reasonsMask = 1 + 2 + 16
          }
        }
        break

      case 'MUSCLE GAIN':
        const muscleGainTargetWeight = carryOverEnvironment.previousWeight + carryOverEnvironment.selectedGoalWeightDelta
        const muscleGainGoalCompleted = amountGoalReached(muscleGainTargetWeight, newWeight, carryOverEnvironment.previousWeight, carryOverEnvironment.daysBetweenCheckIns)
        if (muscleGainGoalCompleted < 1) {
          keepable = true
          if (muscleGainGoalCompleted < 0) {
            reasonsMask = 2 + 4 + 8
            adj = 0.1
          } else {
            reasonsMask = 1 + 2 + 4 + 8
            adj = (1 - muscleGainGoalCompleted) * 10 / 100
          }
        } else if (muscleGainGoalCompleted > 1 && !effectiveNearPeriod) {
          const scaledGainInLbs = muscleGainGoalCompleted * (muscleGainTargetWeight - carryOverEnvironment.previousWeight) * LBS_PER_KG
          goalRatio = carryOverEnvironment.selectedGoalWeightDelta / carryOverEnvironment.previousWeight
          if (goalRatio < 0.002) {
            goalRatio = 0.002
          } else if (goalRatio > 0.005) {
            goalRatio = 0.005
          }
          const muscleGainOffset100 = carryOverEnvironment.selectedInitialWeek ? 2.2 + (goalRatio - 0.002) * 400 / 3 : 0.6
          const muscleGainOffset500 = carryOverEnvironment.selectedInitialWeek ? 4.0 - (goalRatio - 0.002) * 800 / 3 : 1.0
          if(latestWeightInLbs < 100) {
            limitFactor = goalRatio
            limitOffset = muscleGainOffset100
          } else if(latestWeightInLbs > 500) {
            limitFactor = goalRatio
            limitOffset = muscleGainOffset500
          } else {
            limitFactor = goalRatio + (muscleGainOffset500 - muscleGainOffset100) / 400
            limitOffset = muscleGainOffset100 - (muscleGainOffset500 - muscleGainOffset100) / 4
          }
          const allowedWeightGainInLbs = latestWeightInLbs * limitFactor + limitOffset
          if(scaledGainInLbs >= allowedWeightGainInLbs) {
            let muscleGainCalorieDecrease
            if(latestWeightInLbs < 100) {
              muscleGainCalorieDecrease = 100
            } else if (latestWeightInLbs > 500) {
              muscleGainCalorieDecrease = 300
            } else {
              muscleGainCalorieDecrease = (latestWeightInLbs - 100) * 0.5 + 100
            }
            if(scaledGainInLbs > allowedWeightGainInLbs + 2) {
              muscleGainCalorieDecrease += 100
            } else {
              muscleGainCalorieDecrease += (scaledGainInLbs - allowedWeightGainInLbs) * 50
            }
            keepable = true
            adj = - muscleGainCalorieDecrease / (4 * carryOverEnvironment.previousCarbs + 9 * carryOverEnvironment.previousFat)
            reasonsMask = 1 + 2 + 16 + 32
          }
        }
        break

      case 'REVERSE DIETING':
        const goalIntensity = ((userProps.gender === 'MALE' ? carryOverEnvironment.selectedGoalMinWeeklyCalorieIncrease - 5 : carryOverEnvironment.selectedGoalMinWeeklyCalorieIncrease) - 30) / 30
        const caloriesFromCarbsAndFat = 4 * carryOverEnvironment.previousCarbs + 9 * carryOverEnvironment.previousFat
        let calorieIncrease = getCalorieIncrease(carryOverEnvironment.selectedGoalMinWeeklyCalorieIncrease, userProps.gender, caloriesFromCarbsAndFat)
        const weightChanged = getWeightChanged(newWeight, carryOverEnvironment.previousWeight, carryOverEnvironment.daysBetweenCheckIns)
        if (weightChanged < goalIntensity * 0.005 - 0.01) {
          keepable = true
          calorieIncrease += 10 * goalIntensity + 15
        } else if (weightChanged <= goalIntensity * 0.005 + 0.005 || effectiveNearPeriod) {
          keepable = true
        }
        if (keepable) {
          adj = calorieIncrease / caloriesFromCarbsAndFat
          reasonsMask = 1 + 2 + 4 + 8
        }
        break

      case 'MAINTENANCE':
        const maintMargin = carryOverEnvironment.selectedGoalWeightDelta / carryOverEnvironment.selectedTargetWeight
        const maintWeight = carryOverEnvironment.selectedTargetWeight
        const latestChange = (newWeight/maintWeight) - 1
        const prevChange = (carryOverEnvironment.previousWeight/maintWeight) - 1
        if(effectiveNearPeriod && latestChange >= - maintMargin) {
        } else if(latestChange > maintMargin + 0.015) {
          if(prevChange <= maintMargin || newWeight >= carryOverEnvironment.previousWeight) {
            adj = -0.10
          }
        } else if(latestChange > maintMargin) {
          if(prevChange <= maintMargin || newWeight >= carryOverEnvironment.previousWeight) {
            adj = -0.05 - (latestChange - maintMargin) / 0.3
          }
        } else if(latestChange >= -maintMargin) {
        } else if(latestChange >= -maintMargin - 0.015) {
          if(prevChange >= -maintMargin || newWeight <= carryOverEnvironment.previousWeight) {
            adj = 0.05 - (latestChange + maintMargin) / 0.3
          }
        } else {
          if(prevChange >= -maintMargin || newWeight <= carryOverEnvironment.previousWeight) {
            adj = 0.10
          }
        }
        if (adj !== 0) {
          keepable = true
          if(latestChange > 0) {
            reasonsMask = 1 + 2 + 4 + 8
          } else {
            reasonsMask = 1 + 16 + 32
          }
        }
        break

      default:
    }
  }
  if (keepable) {
    const multiplier = 1 + adj
    const tempCarbs = carryOverEnvironment.previousCarbs * multiplier
    const tempFat = carryOverEnvironment.previousFat * multiplier
    let targetCalories = 4 * (carryOverEnvironment.previousProtein + tempCarbs) + 9 * tempFat
    const minimumCalories = newWeight * (1 - newBodyFat / 100) * 19.5
    if (targetCalories < minimumCalories) {
      targetCalories = minimumCalories
    }
    const reportDate = new Date(carryOverEnvironment.selectedReportDate)
    const birthdate = new Date(userProps.birthdate)
    const age = Math.floor((reportDate - birthdate)/(1000*31556926))
    const newProtein = getProteins(age, newWeight, newBodyFat, carryOverEnvironment.selectedGoal, carryOverEnvironment.selectedActivityFactor, carryOverEnvironment.selectedVegan, userProps.extra_protein_level, userProps.algorithm_version)
    const newFat = getFats(carryOverEnvironment.selectedFatPermyriad, targetCalories)
    const newCarbs = (targetCalories - newProtein*4 - newFat*9) / 4
    const oldCalories = (carryOverEnvironment.previousProtein + carryOverEnvironment.previousCarbs) * 4 + carryOverEnvironment.previousFat * 9
    const oldProtein = newProtein
    const oldFat = getFats(carryOverEnvironment.selectedFatPermyriad, oldCalories)
    const oldCarbs = (oldCalories - oldProtein*4 - oldFat*9) / 4
    macros = { old: { protein: Math.round(oldProtein), carbs: Math.round(oldCarbs), fat: Math.round(oldFat) }, new: { protein: Math.round(newProtein), carbs: Math.round(newCarbs), fat: Math.round(newFat) } }
  }
  return { keepable: keepable, reasonsMask: reasonsMask, macros: macros }
}

export function toDateString(date) {
  let dd = date.getDate().toString()
  while (dd.length < 2)
    dd = '0' + dd
  let mm = (date.getMonth() + 1).toString()
  while (mm.length < 2)
    mm = '0' + mm
  return date.getFullYear() + '-' + mm + '-' + dd
}


export function generateBlogURL(post) {

  let tmpCat = ""
  post.categories.forEach(category => {
    if(getBlogCategoryName(category) != null)
      tmpCat = getBlogCategoryName(category)
  })

  return config.HOME_ROOT + '/blog/' + tmpCat + '/' + post.slug
}

export function generateRecipeURL(post) {

  let tmpCat = ""
  post.categories.forEach(category => {
    if(getRecipeCategoryName(category) != null)
      tmpCat = getRecipeCategoryName(category)
  })

  return `${config.HOME_ROOT}/blog/recipes/${tmpCat}/${post.slug}`
}

export function getBlogCategoryName(categoryID) {
  switch(categoryID) {
    case 24: return 'fat-loss'
    case 25: return 'muscle-gain'
    case 26: return 'flexible-dieting'
    case 28: return 'exercise-info'
    case 29: return 'nutrition-info'
    case 30: return 'inspiration'
    case 39: return 'reverse-dieting'
    default: return
  }
}

export function getRecipeCategoryName(categoryID) {
  switch(categoryID) {
    case 42: return 'lunch-dinner'
    case 43: return 'breakfast'
    case 44: return 'dessert'
    case 45: return 'appetizer-snack'
    default: return
  }
}

export function getBlogCategoryId(categoryName) {
  switch(categoryName) {
    case 'fat-loss': return 24
    case 'muscle-gain': return 25
    case 'flexible-dieting': return 26
    case 'recipes': return 27
    case 'exercise-info': return 28
    case 'nutrition-info': return 29
    case 'inspiration': return 30
    case 'reverse-dieting': return 39
    case 'lunch-dinner': return 42
    case 'breakfast': return 43
    case 'dessert': return 44
    case 'appetizer-snack': return 45
    default: return
  }
}

export function extractTextFromPost(post) {
  return post.rendered.split('<p>===</p>')
}

export function splitText(macrosContent) {
  const macrosArray = []

  let proteinNumbers = macrosContent[3].split(': ')[1]
  let carbNumbers = macrosContent[5].split(': ')[1]
  let fatNumbers = macrosContent[4].split(': ')[1]
  let proteinIndex= proteinNumbers.indexOf('G')
  let carbsIndex= carbNumbers.indexOf('G')
  let fatIndex= fatNumbers.indexOf('G')

  let proteinG = '<span style="font-size: 0.7em">' + proteinNumbers.substr(proteinIndex).split('<')[0] + '</span></p>'
  let carbsG = '<span style="font-size: 0.7em">' + carbNumbers.substr(carbsIndex).split('<')[0] + '</span></p>'
  let fatG = '<span style="font-size: 0.7em">' + fatNumbers.substr(fatIndex).split('<')[0] + '</span></p>'

  proteinNumbers = '<p>Protein: ' + proteinNumbers.split(' ')[0] + proteinG
  carbNumbers = '<p>Carbs: ' + carbNumbers.split(' ')[0] + carbsG
  fatNumbers = '<p>Fat: ' + fatNumbers.split(' ')[0] + fatG
  macrosArray.push(proteinNumbers)
  macrosArray.push(carbNumbers)
  macrosArray.push(fatNumbers)
  return macrosArray
}

// Convert date from host (generally 'YYYY-MM-DDT04:00:00.000Z') to 'YYYY-MM-DD'.
export function hostDateToString(hostDate) {
  const date = new Date(hostDate)
  const year = date.getUTCFullYear()
  const month = ('0' + (date.getUTCMonth() + 1)).slice(-2)
  const day = ('0' + date.getUTCDate()).slice(-2)
  return year + '-' + month + '-' + day
}

// Get today (local time) as 'YYYY-MM-DD'.
export function todayString() {
  const date = new Date()
  const year = date.getFullYear()
  const month = ('0' + (date.getMonth() + 1)).slice(-2)
  const day = ('0' + date.getDate()).slice(-2)
  return year + '-' + month + '-' + day
}

// Add offset in days to YYYY-MM-DD, giving new YYYY-MM-DD.
export function dateStringAddDays(dateString, offsetInDays) {
  const oldDate = new Date(dateString + 'T00:00:00.000Z')
  const newDate = new Date(oldDate.valueOf() + 86400000 * offsetInDays)
  const year = newDate.getUTCFullYear()
  const month = ('0' + (newDate.getUTCMonth() + 1)).slice(-2)
  const day = ('0' + newDate.getUTCDate()).slice(-2)
  return year + '-' + month + '-' + day
}

// Get number of days from dateString1 to dateString2.
export function daysBetweenDateStrings(dateString1, dateString2) {
  const date1 = new Date(dateString1 + 'T00:00:00.000Z')
  const date2 = new Date(dateString2 + 'T00:00:00.000Z')
  return Math.round((date2.valueOf() - date1.valueOf()) / 86400000)
}


// Import from avn-native utils for Reverse Diet preview macros
export function getBMR(gender, age, height, weight) {
  switch (gender) {
    case 'MALE':
      return 10 * weight + 6.25 * height * 100 - 5 * age + 5;
    case 'FEMALE':
      return 10 * weight + 6.25 * height * 100 - 5 * age - 161;
  }
}

export function getRMR(bmr, activityFactor) {
  return bmr * activityFactor;
}

export function adjustmentFromGoalLevel(
  goal,
  goalWeightDelta,
  goalMinWeeklyCalorieIncrease,
  gender,
  effectiveWeight,
  algorithmVersion,
) {
  let goalRatio;
  let adjustment;
  switch (goal) {
    case 'FAT LOSS':
      goalRatio = goalWeightDelta / effectiveWeight;
      if (goalRatio < 0.004) {
        goalRatio = 0.004;
      } else if (goalRatio > 0.012) {
        goalRatio = 0.012;
      }
      if (algorithmVersion >= ALGORITHM_VERSION_NEW_ACTIVITY_FACTORS) {
        adjustment =
          -0.20 - (0.30 - 0.20) * (goalRatio - 0.004) / (0.012 - 0.004);
      } else {
        adjustment =
          -0.15 - (0.25 - 0.15) * (goalRatio - 0.004) / (0.012 - 0.004);
      }
      break;

    case 'MUSCLE GAIN':
      goalRatio = goalWeightDelta / effectiveWeight;
      if (goalRatio < 0.002) {
        goalRatio = 0.002;
      } else if (goalRatio > 0.005) {
        goalRatio = 0.005;
      }
      adjustment =
        0.05 + ((0.1 - 0.05) * (goalRatio - 0.002)) / (0.005 - 0.002);
      break;

    case 'REVERSE DIETING':
      const goalIntensity =
        ((gender == 'MALE'
          ? goalMinWeeklyCalorieIncrease - 5
          : goalMinWeeklyCalorieIncrease) -
          30) /
        30;
      adjustment = 0.025 + (0.075 - 0.025) * goalIntensity;
      break;

    case 'MAINTENANCE':
      adjustment = 0;
      break;

    default:
      // should not occur
      adjustment = 0;
  }
  return adjustment;
}

// Get lean body mass in kg
export function getLBM(weight, bodyfat) {
  return weight - (weight * bodyfat) / 100;
}

export function getTargetCalories(
  rmr,
  weight,
  goal,
  targetWeight,
  goalWeightDelta,
  goalMinWeeklyCalorieIncrease,
  previousDietCalories,
  boost,
  gender,
  age,
  bodyfat,
  activityFactor,
  vegan,
  extra,
  algorithmVersion,
) {
  const protein = getProteins(
    age,
    weight,
    bodyfat,
    goal,
    activityFactor,
    vegan,
    extra,
    algorithmVersion,
  );
  const caloriesFromCarbsAndFat = previousDietCalories - 4 * protein;
  let factor;
  let calories;
  switch (goal) {
    case 'FAT LOSS':
      factor = goalWeightDelta / weight;
      if (factor < 0.004) {
        factor = 0.004;
      } else if (factor > 0.012) {
        factor = 0.012;
      }
      if (algorithmVersion >= ALGORITHM_VERSION_NEW_ACTIVITY_FACTORS) {
        calories = rmr - (caloriesFromCarbsAndFat * (factor * 250 + 3)) / 20;
      } else {
        calories = rmr - weight * factor * 500;
      }
      break;

    case 'MUSCLE GAIN':
      factor = goalWeightDelta / weight;
      if (factor < 0.002) {
        factor = 0.002;
      } else if (factor > 0.005) {
        factor = 0.005;
      }
      if (algorithmVersion >= ALGORITHM_VERSION_NEW_ACTIVITY_FACTORS) {
        calories = rmr + (caloriesFromCarbsAndFat * (factor * 1000 + 1)) / 60;
      } else {
        calories = rmr + weight * factor * 1100;
      }
      break;

    case 'REVERSE DIETING':
      const calorieIncrease = getCalorieIncrease(
        goalMinWeeklyCalorieIncrease,
        gender,
        caloriesFromCarbsAndFat,
      );
      calories = previousDietCalories + calorieIncrease;
      if (calories < rmr && boost) {
        calories = calories * (1 + boost / 100);
      }
      break;

    case 'MAINTENANCE':
      calories = rmr;
  }
  return calories;
}

export function getFirstCalorieFloor(weight, bodyfat) {
  return FIRST_CALORIE_FLOOR_FACTOR * getLBM(weight, bodyfat);
}

// End Import from avn-native